import React from 'react';
import Tooltip from '../tooltip/Tooltip';
import { LabelProps } from './types';

const Label = React.forwardRef<HTMLElement, LabelProps>(
	({ visuallyHidden = false, as: Component = 'label', column = false, className, id, required = false, tooltip, ...props }, ref) => {
		const classes = [
			className,
			'form-label',
			typeof column === 'boolean' && column && 'col-form-label col-auto',
			typeof column === 'string' && `col-form-label-${column} col`,
			visuallyHidden && 'visually-hidden'
		]
			.filter(Boolean)
			.join(' ');
		return props.children ? (
			<Component ref={ref} className={classes} id={id} {...props}>
				{props.children}
				{required && <span className="text-danger"> *</span>}
				<Tooltip data-testid="tooltip-wrapper" id={id ? id + '_tooltip' : undefined}>
					{tooltip}
				</Tooltip>
			</Component>
		) : null;
	}
);

Label.displayName = 'Label';
export default Label;
